import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authLogin, authLogout, authMe, setOnUnauthorized } from "../lib/api";

const AuthContext = createContext({});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = useCallback(async () => {
    const refresh = localStorage.getItem("refresh_token");
    if (refresh) {
      try { await authLogout(refresh); } catch { /* ignore */ }
    }
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    setUser(null);
  }, []);

  // Bootstrap: se c'è un access_token, prova a recuperare l'utente
  useEffect(() => {
    setOnUnauthorized(() => {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      setUser(null);
    });
    const token = localStorage.getItem("access_token");
    if (!token) {
      setLoading(false);
      return;
    }
    authMe()
      .then(setUser)
      .catch(() => {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const data = await authLogin(email, password);
    localStorage.setItem("access_token", data.access_token);
    localStorage.setItem("refresh_token", data.refresh_token);
    setUser(data.user);
    return data.user;
  };

  const refreshMe = async () => {
    const u = await authMe();
    setUser(u);
    return u;
  };

  const isAdmin = user?.ruolo === "AMMINISTRATORE";
  const isOffice = user?.ruolo === "UFFICIO";
  const isCarrier = user?.ruolo === "TRASPORTATORE";
  const canSeeCommercial = isAdmin || isOffice;

  return (
    <AuthContext.Provider value={{
      user, loading, login, logout, refreshMe,
      isAdmin, isOffice, isCarrier, canSeeCommercial,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
